module.exports = __webpack_public_path__ + "static/media/image-placeholder.6c6d8a34.jpg";